var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52,0C23.33,0,0,23.33,0,52s23.33,52,52,52,52-23.33,52-52S80.67,0,52,0ZM52,100c-26.47,0-48-21.53-48-48S25.53,4,52,4s48,21.53,48,48-21.53,48-48,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.42,30.59c-.09-.09-.2-.18-.31-.25-.05-.03-.1-.05-.15-.08-.06-.04-.13-.07-.2-.1-.07-.03-.13-.04-.2-.06-.06-.02-.11-.04-.17-.05-.26-.05-.52-.05-.78,0-.06.01-.12.03-.17.05-.07.02-.13.04-.2.06-.07.03-.13.07-.2.1-.05.03-.1.05-.15.08-.11.07-.21.16-.31.25l-20,20c-.78.78-.78,2.05,0,2.83.78.78,2.05.78,2.83,0l16.59-16.59v35.17c0,1.1.9,2,2,2s2-.9,2-2v-35.17l16.59,16.59c.39.39.9.59,1.41.59s1.02-.2,1.41-.59c.78-.78.78-2.05,0-2.83l-20-20Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ea72dfb2744e5f32cb2c8ae6b59b96f2.svg";
export { ForwardRef as ReactComponent };